/* PSI photo upload — replaces Uploadery (25 Oct 2026).
   Each slot is a real <input type=file> tied to the product form (form="product-form-…").
   A slot only gets its name="properties[key]" once it holds a photo, so empty months add nothing to the order.
   Big phone photos are resized in the browser (long side 2400px, JPEG 90%) so add-to-cart stays fast. */
(function () {
  if (customElements.get('psi-photo-upload')) return;
  var MAX_SIDE = 2400, SHRINK_OVER = 1.5 * 1024 * 1024, HARD_LIMIT = 19 * 1024 * 1024;

  function shrink(file) {
    var looksImage = /^image\//.test(file.type) || /\.(heic|heif|jpe?g|png|webp)$/i.test(file.name);
    if (!looksImage) return Promise.reject(new Error('type'));
    if (file.size <= SHRINK_OVER && /^image\/(jpe?g|png|webp)$/.test(file.type)) return Promise.resolve(file);
    if (!window.createImageBitmap) return Promise.resolve(file);
    return createImageBitmap(file, { imageOrientation: 'from-image' }).then(function (bmp) {
      var k = Math.min(1, MAX_SIDE / Math.max(bmp.width, bmp.height));
      var w = Math.round(bmp.width * k), h = Math.round(bmp.height * k);
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h); ctx.drawImage(bmp, 0, 0, w, h);
      if (bmp.close) bmp.close();
      return new Promise(function (res) { c.toBlob(res, 'image/jpeg', 0.9); });
    }).then(function (blob) {
      if (!blob) return file;
      var base = (file.name || 'photo').replace(/\.[^.]+$/, '');
      return new File([blob], base + '.jpg', { type: 'image/jpeg', lastModified: file.lastModified || Date.now() });
    }).catch(function () { return file; });
  }

  function cheer(n, total) {
    if (total <= 1) return n ? 'Lovely! Your photo is added.' : '';
    if (n === 0) return '';
    if (n === total) return 'All ' + total + ' months added. This is going to look adorable!';
    if (n >= Math.ceil(total * 0.75)) return 'Almost there! Just ' + (total - n) + ' more.';
    if (n >= Math.ceil(total / 2)) return 'Halfway there! ' + (total - n) + ' more to go.';
    return 'Lovely start! ' + (total - n) + ' more to go.';
  }

  class PsiPhotoUpload extends HTMLElement {
    connectedCallback() {
      this.total = +this.dataset.total || 1;
      this.slots = Array.prototype.slice.call(this.querySelectorAll('[data-slot]'));
      this.msg = this.querySelector('[data-msg]');
      var self = this;
      this.slots.forEach(function (slot) {
        var input = slot.querySelector('[data-input]');
        input.addEventListener('change', function () { if (input.files && input.files[0]) self.place(slot, input.files[0]); });
        slot.querySelector('[data-remove]').addEventListener('click', function (e) { e.preventDefault(); self.clear(slot); });
        var tile = slot.querySelector('.psi-pu__tile');
        ['dragenter', 'dragover'].forEach(function (t) { tile.addEventListener(t, function (e) { e.preventDefault(); tile.classList.add('is-drag'); }); });
        ['dragleave', 'drop'].forEach(function (t) { tile.addEventListener(t, function () { tile.classList.remove('is-drag'); }); });
        var mv = slot.querySelector('[data-move]');
        if (mv) {
          mv.addEventListener('pointerdown', function (e) { self.dragStart(e, slot, mv); });
          mv.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (self.dragMoved) { self.dragMoved = false; return; } if (self.picking === slot) self.endPick(); else self.pick(slot); });
        }
        tile.addEventListener('click', function (e) {
          if (!self.picking) return;
          e.preventDefault(); e.stopPropagation();
          var src = self.picking; self.endPick();
          if (src !== slot) self.swap(src, slot);
        }, true);
        tile.addEventListener('drop', function (e) { e.preventDefault(); var f = e.dataTransfer && e.dataTransfer.files; if (f && f.length) self.fill(Array.prototype.slice.call(f), slot); });
      });
      var bulk = this.querySelector('[data-bulk]');
      if (bulk) bulk.addEventListener('change', function () {
        var files = Array.prototype.slice.call(bulk.files || []);
        bulk.value = '';
        files.sort(function (a, b) { return (a.lastModified || 0) - (b.lastModified || 0); });
        self.fill(files);
      });
      var form = document.getElementById(this.dataset.form);
      if (form) form.addEventListener('submit', function () {
        if (self.filledCount()) self.say('Sending your photos with the order… this takes a few seconds.', false);
      }, true);
      document.addEventListener('cart:updated', function () { self.update(); });
      this.update(true);
    }
    label(slot) { var l = slot.querySelector('.psi-pu__label'); return l ? l.textContent.trim() : ''; }
    pick(slot) {
      this.endPick(); this.picking = slot; slot.classList.add('is-picked'); this.classList.add('is-picking');
      this.say('Now tap the month where this photo should go.', false);
    }
    endPick() { if (this.picking) this.picking.classList.remove('is-picked'); this.picking = null; this.classList.remove('is-picking'); }
    dragStart(e, slot, handle) {
      if (e.button && e.button !== 0) return;
      e.preventDefault();
      var self = this, img = slot.querySelector('[data-img]'), sx = e.clientX, sy = e.clientY, moved = false, over = null;
      var ghost = document.createElement('img'); ghost.className = 'psi-pu__ghost'; ghost.src = img.src; ghost.alt = '';
      function pos(x, y) { ghost.style.transform = 'translate(' + (x - 38) + 'px,' + (y - 46) + 'px)'; }
      function move(ev) {
        if (!moved && Math.abs(ev.clientX - sx) + Math.abs(ev.clientY - sy) > 6) { moved = true; document.body.appendChild(ghost); slot.classList.add('is-lifting'); self.endPick(); }
        if (!moved) return;
        pos(ev.clientX, ev.clientY);
        var el = document.elementFromPoint(ev.clientX, ev.clientY), t = el && el.closest && el.closest('[data-slot]');
        if (t && !self.contains(t)) t = null;
        if (over !== t) { if (over) over.classList.remove('is-target'); over = t; if (over && over !== slot) over.classList.add('is-target'); }
        if (ev.clientY < 70) window.scrollBy(0, -14); else if (ev.clientY > window.innerHeight - 70) window.scrollBy(0, 14);
      }
      function up() {
        handle.removeEventListener('pointermove', move); handle.removeEventListener('pointerup', up); handle.removeEventListener('pointercancel', up);
        if (ghost.parentNode) ghost.remove(); slot.classList.remove('is-lifting'); if (over) over.classList.remove('is-target');
        if (moved) { self.dragMoved = true; if (over && over !== slot) self.swap(slot, over); setTimeout(function () { self.dragMoved = false; }, 400); }
      }
      try { handle.setPointerCapture(e.pointerId); } catch (err) {}
      handle.addEventListener('pointermove', move); handle.addEventListener('pointerup', up); handle.addEventListener('pointercancel', up);
    }
    setSlot(slot, file, url) {
      var input = slot.querySelector('[data-input]'), img = slot.querySelector('[data-img]'), on = !!file;
      if (on) { var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; input.name = 'properties[' + slot.dataset.key + ']'; img.dataset.url = url; img.src = url; }
      else { input.value = ''; input.removeAttribute('name'); delete img.dataset.url; img.removeAttribute('src'); }
      img.hidden = !on; slot.querySelector('[data-tick]').hidden = !on; slot.querySelector('[data-remove]').hidden = !on;
      var mv = slot.querySelector('[data-move]'); if (mv) mv.hidden = !on;
      slot.classList.toggle('is-filled', on);
      if (on) { slot.classList.add('is-new'); setTimeout(function () { slot.classList.remove('is-new'); }, 500); }
    }
    swap(a, b) {
      var ia = a.querySelector('[data-input]'), ib = b.querySelector('[data-input]');
      var fa = (ia.files && ia.files[0]) || null, fb = (ib.files && ib.files[0]) || null;
      var ua = a.querySelector('[data-img]').dataset.url || null, ub = b.querySelector('[data-img]').dataset.url || null;
      if (!fa) return;
      this.setSlot(b, fa, ua); this.setSlot(a, fb, ub);
      this.update(true);
      this.say(fb ? 'Swapped ' + this.label(a) + ' and ' + this.label(b) + '.' : 'Moved to ' + this.label(b) + '.', false);
      try { window.clarity && window.clarity('event', 'psi_upload_reorder'); } catch (e) {}
    }
    filledCount() { return this.slots.filter(function (s) { return s.classList.contains('is-filled'); }).length; }
    fill(files, startSlot) {
      var empties = this.slots.filter(function (s) { return !s.classList.contains('is-filled'); });
      if (startSlot) { empties = [startSlot].concat(empties.filter(function (s) { return s !== startSlot; })); }
      var self = this, extra = files.length - empties.length;
      files.slice(0, empties.length).forEach(function (f, i) { self.place(empties[i], f); });
      if (extra > 0) this.say(extra + (extra === 1 ? ' photo was' : ' photos were') + ' left out because every month is filled. Tap a month to swap a photo.', true);
    }
    place(slot, file) {
      var self = this, input = slot.querySelector('[data-input]'), img = slot.querySelector('[data-img]'), busy = slot.querySelector('[data-busy]');
      busy.hidden = false;
      shrink(file).then(function (f) {
        if (f.size > HARD_LIMIT) throw new Error('size');
        var dt = new DataTransfer(); dt.items.add(f); input.files = dt.files;
        input.name = 'properties[' + slot.dataset.key + ']';
        if (img.dataset.url) URL.revokeObjectURL(img.dataset.url);
        img.dataset.url = URL.createObjectURL(f); img.src = img.dataset.url; img.hidden = false;
        slot.querySelector('[data-tick]').hidden = false; slot.querySelector('[data-remove]').hidden = false; var mvb = slot.querySelector('[data-move]'); if (mvb) mvb.hidden = false;
        slot.classList.add('is-filled', 'is-new'); setTimeout(function () { slot.classList.remove('is-new'); }, 500);
        self.update();
      }).catch(function (err) {
        self.clear(slot, true);
        self.say(err && err.message === 'size' ? 'That photo is too large. Please pick a smaller one (under 19 MB).' : 'That file isn’t a photo we can use. Please pick a JPG or PNG.', true);
      }).then(function () { busy.hidden = true; });
    }
    clear(slot, quiet) {
      var input = slot.querySelector('[data-input]'), img = slot.querySelector('[data-img]');
      input.value = ''; input.removeAttribute('name');
      if (img.dataset.url) { URL.revokeObjectURL(img.dataset.url); delete img.dataset.url; }
      img.removeAttribute('src'); img.hidden = true;
      slot.querySelector('[data-tick]').hidden = true; slot.querySelector('[data-remove]').hidden = true; var mvc = slot.querySelector('[data-move]'); if (mvc) mvc.hidden = true;
      slot.classList.remove('is-filled');
      if (!quiet) this.update();
    }
    say(text, warn) { if (!this.msg) return; this.msg.textContent = text; this.msg.classList.toggle('is-warn', !!warn); }
    update(silent) {
      var n = this.filledCount(), c = this.querySelector('[data-count]'), bar = this.querySelector('[data-bar]');
      if (c) c.textContent = n;
      if (bar) bar.style.width = (n / this.total * 100) + '%';
      this.classList.toggle('is-complete', n === this.total);
      var tip = this.querySelector('[data-tip]'); if (tip) tip.hidden = n < 2;
      if (!silent) this.say(cheer(n, this.total), false);
    }
  }
  customElements.define('psi-photo-upload', PsiPhotoUpload);
})();
